export enum ExceptionSeverity {
    CRITICAL = 'CRITICAL',
    HIGH = 'HIGH',
    MODERATE = 'MODERATE',
    LOW = 'LOW'
}

